import { DateInput, ReadOnlyInput, TextInput } from '@core/components/Inputs';
import { FormControlLabel, Grid, Switch, Typography } from '@material-ui/core';
import { InputMonetario } from 'app/components/Input';
import { getCurrency } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { ContasPagarAcrescimosDescontos } from '../../components';
import ContasPagarPagamentosRealizados from '../ContasPagarPagamentosRealizados';

const ContasPagarAbaBaixa = () => {
  const formikContext = useFormikContext();

  const [baixaEmParcelas, setBaixaEmParcelas] = useState(false);

  const { values, handleChange, handleBlur, errors, touched } = formikContext;

  const despesaParcelada = values?.parcelamento?.parcelas?.length > 1;

  /*
  RNE-478 - Edição de conta a pagar
  Para as contas a pagar que estiverem com situação "Baixada", somente a aba “Anexar documento” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição.

  Para as contas a pagar que estiverem com a situação “Parcial”, somente as abas “Anexar documento” e “Baixa da conta principal” deve ser exibida com possibilidade de edição. Todos os outros campos das outras abas devem ser exibidos desabilitados para edição. 
  */
  const contaBaixada =
    values?.situacao === 'BAIXADA' || (values?.situacao === 'PARCIALMENTE_BAIXADA' && values?.numeroParcelas > 0);

  const [cancelarBaixasFull, setCancelarBaixasFull] = useState(false);

  const valuesCancelarBaixas = values?.cancelarBaixas;
  useEffect(() => {
    if (valuesCancelarBaixas !== undefined) {
      if (values?.parcelamento?.parcelas !== undefined) {
        var somaQuantidadeBaixasEmParcelas = 0;

        for (let i = 0; i < values?.parcelamento?.parcelas?.length; i++) {
          somaQuantidadeBaixasEmParcelas += values?.parcelamento?.parcelas[i]?.baixas?.length || 0;
        }

        if (valuesCancelarBaixas.length === somaQuantidadeBaixasEmParcelas) {
          setCancelarBaixasFull(true);
        }
      } else {
        if (valuesCancelarBaixas.length === values?.baixas.length) {
          setCancelarBaixasFull(true);
        }
      }
    }
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesCancelarBaixas]);

  const primeiraParcelaSituacaoParcialOuAberta =
    values?.parcelamento?.parcelas?.length > 0 &&
    (values?.parcelamento?.parcelas[0]?.situacao === 'PARCIAL' ||
      values?.parcelamento?.parcelas[0]?.situacao === 'ABERTA');

  const disabled = contaBaixada ? (primeiraParcelaSituacaoParcialOuAberta ? false : true) : false;

  const disabledUnica = contaOrigemBaixada();

  function contaOrigemBaixada() {
    if (!!values?.baixas) {
      const somatorioValorPagoBaixas = values?.baixas?.reduce((acc, baixa) => acc + baixa.valorPago, 0);
      const valorLiquido = values?.valorLiquido;

      return somatorioValorPagoBaixas >= valorLiquido;
    } else {
      return false;
    }
  }

  const alterarDataBaixa = (_) => {
    handleChange(_);
    if (values?.numeroParcelas > 1) {
      handleChange({ target: { id: 'parcelamento.parcelas[0].contemBaixa', value: !!_.target.value } });
    }
  };

  useEffect(() => {
    verificarBaixaEmParcelas();

    if (despesaParcelada) {
      values.valorContaOrigem = getValorContaOrigemDespesaParcelada(values);
    } else {
      values.valorContaOrigem = getValorContaOrigemDespesaUnica(values);
    }
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const baixaValorPago = values.baixa?.valorPago;
  useEffect(() => {
    if (values.valorContaOrigem !== undefined) {
      const valorContaOrigem = values.valorContaOrigem || 0;
      const valorPago = baixaValorPago || 0;
      const valorRetencoes = values.retencoes?.reduce((acc, ret) => acc + ret.valor, 0) || 0;

      let valorEmAberto = 0;

      if (values?.tipoDespesa === 'PARCELADA') {
        valorEmAberto = valorContaOrigem - valorPago;
      } else {
        valorEmAberto = valorContaOrigem - valorPago - valorRetencoes;
      }

      valorEmAberto = Math.round(valorEmAberto * 100) / 100;

      formikContext.setFieldValue('baixa.valorEmAberto', valorEmAberto);
    }
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baixaValorPago, values.valorContaOrigem]);

  const verificarBaixaEmParcelas = () => {
    if (values?.parcelamento?.parcelas?.length > 0) {
      for (let i = 0; i < values?.parcelamento?.parcelas?.length; i++) {
        if (values?.parcelamento?.parcelas[i]?.baixas?.length > 0) {
          setBaixaEmParcelas(true);
          break;
        }
      }
    }
  };

  const getValorContaOrigemDespesaParcelada = (values) => {
    var valorContaOrigem = values?.parcelamento?.parcelas[0]?.valorLiquido || 0;

    for (let i = 0; i < values?.parcelamento?.parcelas[0]?.baixas?.length; i++) {
      const juros = values?.parcelamento?.parcelas[0]?.baixas[i]?.juros?.valor || 0;
      const multa = values?.parcelamento?.parcelas[0]?.baixas[i]?.multa?.valor || 0;
      const desconto = values?.parcelamento?.parcelas[0]?.baixas[i]?.desconto?.valor || 0;
      const valorPago = values?.parcelamento?.parcelas[0]?.baixas[i]?.valorPago || 0;

      valorContaOrigem -= valorPago - juros - multa + desconto;
    }

    return valorContaOrigem;
  };

  const getValorContaOrigemDespesaUnica = (values) => {
    var valorContaOrigem = 0;

    for (let i = 0; i < values?.categorias?.length; i++) {
      valorContaOrigem += values?.categorias[i]?.valorBruto;
    }

    if (!!values?.baixas && values?.baixas.length > 0) {
      for (let i = 0; i < values?.baixas.length; i++) {
        const juros = values?.baixas[i]?.juros?.valor || 0;
        const multa = values?.baixas[i]?.multa?.valor || 0;
        const desconto = values?.baixas[i]?.desconto?.valor || 0;
        const valorPago = values?.baixas[i]?.valorPago || 0;

        valorContaOrigem -= valorPago - juros - multa + desconto;
      }
    }

    return valorContaOrigem;
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <DateInput
          autoFocus
          fullWidth
          required
          id="baixa.dataPagamento"
          label="Data do pagamento"
          value={values?.baixa?.dataPagamento}
          onChange={alterarDataBaixa}
          onBlur={handleBlur}
          disabled={disabled || disabledUnica}
          error={errors?.baixa?.dataPagamento}
          helperText={errors?.baixa?.dataPagamento}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DateInput
          autoFocus
          fullWidth
          required
          id="baixa.dataLiquidacao"
          label="Data da liquidação"
          value={values?.baixa?.dataLiquidacao}
          onChange={alterarDataBaixa}
          onBlur={handleBlur}
          disabled={disabled || disabledUnica}
          error={errors?.baixa?.dataLiquidacao}
          helperText={errors?.baixa?.dataLiquidacao}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <InputMonetario
          fullWidth
          required
          id="baixa.valorPago"
          label="Valor (R$)"
          onBlur={handleBlur}
          disabled={disabled || disabledUnica}
          value={values?.baixa?.valorPago}
          touched={errors?.baixa?.valorPago}
          error={errors?.baixa?.valorPago}
          helperText={errors?.baixa?.valorPago}
          handleChange={handleChange}
        />
      </Grid>
      {values?.valorContaOrigem !== undefined && values?.baixa?.valorEmAberto > 0 && !disabled && !disabledUnica && (
        <Grid item xs={6} sm={3}>
          <ReadOnlyInput
            fullWidth
            disabled={disabled || disabledUnica}
            id="baixa.valorEmAberto"
            label="Valor em aberto (R$)"
            error={errors?.baixa?.valorEmAberto}
            helperText={errors?.baixa?.valorEmAberto}
            value={getCurrency(values?.baixa?.valorEmAberto)}
          />
        </Grid>
      )}
      {values?.formaPagamento === 'CHEQUE' && (
        <Grid item xs={12} sm={6}>
          <TextInput
            fullWidth
            required
            id="baixa.numeroCheque"
            label="Número do cheque"
            value={values?.baixa?.numeroCheque}
            disabled={disabled || disabledUnica}
            onChange={handleChange}
            maxLength={20}
            pattern={/^\d*$/}
            error={errors?.baixa?.numeroCheque}
            helperText={errors?.baixa?.numeroCheque}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <FormControlLabel
          label="Incluir acréscimos e descontos"
          control={
            <Switch
              id="acrescimosDescontos"
              name="acrescimosDescontos"
              value={values?.acrescimosDescontos}
              checked={values?.acrescimosDescontos}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={disabled || disabledUnica}
              color="primary"
            />
          }
        />
      </Grid>

      {values?.acrescimosDescontos && (
        <ContasPagarAcrescimosDescontos
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          values={values}
          disabled={disabled}
        />
      )}
      {values?.baixa && values?.baixa?.valorEmAberto < 0 && !disabled && !disabledUnica && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography style={{ fontSize: 15, fontWeight: 500, color: '#f00' }}>
            Diferença: {getCurrency(values?.baixa?.valorEmAberto)}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} sm={12}>
        {(baixaEmParcelas || values?.baixas?.length > 0) && !cancelarBaixasFull && (
          <ContasPagarPagamentosRealizados
            parcelas={values?.parcelamento?.parcelas || undefined}
            baixas={values?.baixas || undefined}
            formik={formikContext}
          />
        )}
      </Grid>
    </>
  );
};

export default ContasPagarAbaBaixa;
